import { FC } from 'react';
import { Link } from 'react-router-dom';

import { DateTimeUtils } from '@servicetitan/datetime-utils';
import { Link as AnvilLink, Headline, Layout, Page } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { releases } from '../assets/releases';
import { ReleaseListSidebar } from './release-list-sidebar';
import * as Styles from './docs.module.scss';

export const ReleaseListPage: FC = () => {
    const [dateTimeUtils] = useDependencies(DateTimeUtils);

    return (
        <Page
            header={<Headline size="large">Release Notes</Headline>}
            sidebar={<ReleaseListSidebar />}
        >
            <Layout>
                <Layout.Section>
                    <AnvilLink
                        primary
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeb51Rx8jADkf-VZMMw-R4AViZgkUoLu-K7lz7tb9kyquO17g/viewform"
                    >
                        Subscribe/unsubscribe
                    </AnvilLink>{' '}
                    to receive ServiceTitan API release notes by email.
                </Layout.Section>
                <Layout.Section>
                    <table className={Styles.simple}>
                        <thead>
                            <tr>
                                <th>Version</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {releases.map(release => (
                                <tr key={release.version}>
                                    <td>
                                        <Link
                                            className="Link Link--blue"
                                            to={`/docs/release-notes/${release.version}`}
                                        >
                                            {`ST-${release.version}`}
                                        </Link>
                                    </td>
                                    <td>
                                        {dateTimeUtils.formatFullMonthDate(
                                            new Date(release.date + 'T00:00:00'),
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Layout.Section>
            </Layout>
        </Page>
    );
};
ReleaseListPage.displayName = 'ReleaseListPage';
